/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_This_MonthInputs */

const en_directory_launch_this_month = /** @type {(inputs: Directory_Launch_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month`)
};

const zh_directory_launch_this_month = /** @type {(inputs: Directory_Launch_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月`)
};

/**
* | output |
* | --- |
* | "This month" |
*
* @param {Directory_Launch_This_MonthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_this_month = /** @type {((inputs?: Directory_Launch_This_MonthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_This_MonthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_this_month(inputs)
	return zh_directory_launch_this_month(inputs)
});
export { directory_launch_this_month as "directory.launch.this_month" }